import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { setData } from '../../features/gssVitalSlice';
import TextField from '../shared/TextField';
import Tip from '../shared/Tip';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  {
    root: {},
    header: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$13,
      margin: '0 0 64px 0',
      '& > a': {
        fontSize: '13px',
        fontWeight: '400',
        lineHeight: '1.38',
        color: color.$2,
        textDecoration: 'underline',
      },
    },
    text: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$11,
      marginBottom: 12,
      maxWidth: 676,
      '& > a': {
        color: color.$2,
      },
    },
    title: {
      fontSize: '20px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 12,
    },
    input: {
      width: 676,
      marginBottom: 12,
    },
    hr: {
      height: 1,
      width: '100%',
      backgroundColor: color.$9,
      margin: '24px 0',
    },
    tip: {
      marginTop: 44,
      maxWidth: 561,
    },
  },
  {
    name: 'TokenContainer',
  },
);

const TokenContainer = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, isSaved } = useSelector(store => store.gssVital);
  const { storeName, apiKey } = data || {};

  const handlesChange = v => {
    dispatch(setData(v));
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>{t('gssVital:settingTitle')}</div>
      <div className={classes.text}>{t('gssVital:step1')}</div>
      <div className={classes.title}>{t('gssVital:step1-title')}</div>
      <div className={classes.text}>
        {t('gssVital:step1-text2-1')}
        <a
          href={t('gssVital:gssVitalUrl')}
          rel="noopener noreferrer"
          target="_blank"
          className="link"
        >
          {t('gssVital:gssVital-text')}
        </a>
        {t('gssVital:step1-text2-2')}
      </div>
      <TextField
        className={classes.input}
        type="text"
        isValid
        value={storeName}
        placeholder={t('gssVital:storeNamePlaceholder')}
        onChange={e => handlesChange({ storeName: e.target.value })}
        isError={isSaved && !storeName}
      />
      <hr className={classes.hr} />
      <div className={classes.text}>{t('gssVital:step2')}</div>
      <div className={classes.title}>{t('gssVital:step2-title')}</div>
      <div className={classes.text}>{t('gssVital:step2-text')}</div>
      <TextField
        className={classes.input}
        type="text"
        isValid
        value={apiKey}
        placeholder={t('gssVital:apiKeyPlaceholder')}
        onChange={e => handlesChange({ apiKey: e.target.value })}
        isError={isSaved && !apiKey}
      />
      <div className={classes.text}>{t('gssVital:step2-text2')}</div>
      <Tip className={classes.tip} text={t(`gssVital:tip`)} />
    </div>
  );
};

export default TokenContainer;
